import React, {PureComponent} from "react"
import {Body} from "@irati/ui/src/Typography"
import {FormattedMessage} from "@irati/utils/lang"

interface Props {
  id: string
}

export default class NoComments extends PureComponent<Props> {
  static defaultProps = {
    id: "no-comments"
  }

  render() {
    const {id} = this.props
    return (
      <Body id={id} small marginBottom={1} textAlign="center">
        <FormattedMessage id="recognition.popup.shared.comments.noComments" />
      </Body>
    )
  }
}
